import { IFormField } from '@ViewModels';
import { v4 as uuid } from 'uuid';

/**
 * Copy a flat-editor question under fresh question and option ids, each option pointing at the
 * copy — otherwise the BE merges the copied options onto the original field. `_type` is dropped
 * because this editor treats a field that carries it as already saved.
 */
export const duplicateFormField = (field: IFormField<string>): IFormField<string> => {
	const { _type: _savedMarker, ...rest } = field;
	const id = uuid();
	return {
		...rest,
		id,
		...(field.options ? { options: field.options.map(option => ({ ...option, id: uuid(), fieldId: id })) } : {}),
	};
};
